enum HonorarioAnestesistaEnum {
  Convenio = 'Convenio',
  Particular = 'Particular',
  Consultorio = 'Consultorio',
  Hospital = 'Hospital',
  AssociacaoMedica = 'AssociacaoMedica'
}

export default HonorarioAnestesistaEnum
